import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import DownloadLink from './components/DownloadLink'
Vue.config.productionTip = false

// Bootstrap
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'primeicons/primeicons.css';



Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// Croppa
import Croppa from 'vue-croppa';
import 'vue-croppa/dist/vue-croppa.css';


// As a plugin
import VueMask from 'v-mask'
Vue.use(VueMask);

Vue.use(Croppa);


Vue.prototype.$strings = {
  appName : "Ins4Models",
  partner: "Inter Partner Assistance S.A. – Rappresentanza Generale per l'Italia, also known as Axa Assistance",
  us: "Strategica Insurance Management S.r.l",  
}

Vue.component('download', DownloadLink)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
